import { useAuthStore } from '@/shared/stores/auth-store';
import { useSearch } from '@tanstack/react-router';
import { DEFAULT_TAB, type TabId, abaSoAdmin, isValidTab } from './secoes';
import { ApiDocsTab } from './tabs/ApiDocsTab';
import { ApiKeysTab } from './tabs/ApiKeysTab';
import { AvaliacaoTab } from './tabs/AvaliacaoTab';
import { ClosingReasonsTab } from './tabs/ClosingReasonsTab';
import { CustomFieldsTab } from './tabs/CustomFieldsTab';
import { DepartmentsTab } from './tabs/DepartmentsTab';
import { FeriadosTab } from './tabs/FeriadosTab';
import { GruposAcessoTab } from './tabs/GruposAcessoTab';
import { LgpdTab } from './tabs/LgpdTab';
import { MediaLibraryTab } from './tabs/MediaLibraryTab';
import { PerfisAcessoTab } from './tabs/PerfisAcessoTab';
import { PushTab } from './tabs/PushTab';
import { QuickRepliesTab } from './tabs/QuickRepliesTab';
import { TagsTab } from './tabs/TagsTab';
import { TemplatesTab } from './tabs/TemplatesTab';
import { UsersTab } from './tabs/UsersTab';
import { WebhooksTab } from './tabs/WebhooksTab';

/**
 * Página de Configurações. Sem menu lateral (rebrand, out/2026): a navegação
 * entre as abas é pelo dropdown "Configurações" do menu do topo, montado a
 * partir de `SECOES_CONFIG` (./secoes).
 */
export function ConfiguracoesPage() {
  // Aba persiste na URL como `?tab=...` — F5 mantém, link compartilhado abre
  // direto na aba certa. Strict:false porque o tipo do search é definido em
  // router.tsx (acoplamento via path string vs import de Route).
  const search = useSearch({ strict: false }) as { tab?: string };
  const ehAdmin = useAuthStore((s) => s.user?.profile === 'admin');
  // Aba só de admin aberta por link por quem não é admin: cai na padrão (a API
  // recusaria de qualquer jeito).
  const tab: TabId =
    isValidTab(search.tab) && (ehAdmin || !abaSoAdmin(search.tab)) ? search.tab : DEFAULT_TAB;

  return (
    <div className="flex h-full min-w-0 flex-1 bg-n-50">
      <main className="min-w-0 flex-1 overflow-y-auto" style={{ padding: '24px 20px' }}>
        {tab === 'quick-replies' && <QuickRepliesTab />}
        {tab === 'closing-reasons' && <ClosingReasonsTab />}
        {tab === 'holidays' && <FeriadosTab />}
        {tab === 'tags' && <TagsTab />}
        {tab === 'templates' && <TemplatesTab />}
        {tab === 'media-library' && <MediaLibraryTab />}
        {tab === 'avaliacao' && <AvaliacaoTab />}
        {tab === 'users' && <UsersTab />}
        {tab === 'departments' && <DepartmentsTab />}
        {tab === 'access-groups' && <GruposAcessoTab />}
        {tab === 'access-profiles' && <PerfisAcessoTab />}
        {tab === 'custom-fields' && <CustomFieldsTab />}
        {tab === 'lgpd' && <LgpdTab />}
        {tab === 'webhooks' && <WebhooksTab />}
        {tab === 'push' && <PushTab />}
        {tab === 'api-keys' && <ApiKeysTab />}
        {tab === 'api-docs' && <ApiDocsTab />}
      </main>
    </div>
  );
}
